<template>
    <div class="page">
        <div class="bgImg" :style="{backgroundImage: 'url('+detail.typicalImg+')' }">
            <span class="pdName">{{detail.pdName}}</span>
        </div>

        <van-tabs v-model="active"
                  sticky
                  animated
                  swipeable
                  nav-left
                  color="#00CE9F"
                  line-width="50px"
                  title-active-color="#1D2123"
                  title-inactive-color="#6F747A">
            <van-tab title="简介">
                    <ul class="lis">
                        <li class="lisItem" v-for="item in synopsis">
                            <h6 class="title">{{item.name}}</h6>
                            <p class="content">{{item.value}}</p>
                        </li>
                    </ul>
                    <div class="imgBox">
                        <div class="imgs"
                             @touchmove.stop
                             :style="{width: 150 * detail.harmStateImgs.length +'px'}">
                            <img v-for="(img,index) in detail.harmStateImgs"
                                 v-lazy="img.imgUrl"
                                 @click="previewImg(detail.harmStateImgs , index)"/>
                        </div>
                    </div>
            </van-tab>
            <van-tab title="防治建议">
                <h6 class="titleP"> &nbsp;&nbsp;防治建议</h6>
                <ul class="prevent">
                    <li class="item" v-for="item in detail.preventionAdvice">
                        <h6 class="title">{{item.keyName}}</h6>
                        <p class="content">{{item.value}}</p>
                    </li>
                </ul>

                <div class="tip">
                    <h6>注意事项</h6>
                    <p>在实际作物管理和用药防治过程中，请按照田间实际情况进行调整，该方案仅供参考。</p>
                </div>
            </van-tab>
        </van-tabs>

        <div class="fixedBottom">
            <div class="btn" id="downloadButton" @click="toDownload">
                <p>下载应用</p>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import {Lazyload} from 'vant';
  import moment from "moment"

  Vue.use(Lazyload);
  import { ImagePreview } from 'vant';
  export default {
    data() {
      return {
          pdId: '',
          detail:{
              typicalImg:'',
              harmStateImgs:[]
          },

          synopsis:[],//简介
          active: 0,
          moment: moment
      }
    },
    created() {
      this.pdId = this.$route.params && this.$route.params.id
      this.getPdDetail()
    },
    methods: {
      //获取病虫害详情
      getPdDetail() {
        const {pdId} = this
        this.$api.getPdDetail({pdId}).then(res => {
          if (res.code === 0) {
             this.detail = res.data
              //标题
             let title = res.data.pdName
             if (title.length > 10) {
               title = title.slice(0, 10) + '...'
             }
             document.title = title
              //简介
              this.synopsis.push({name: '分类及别名', value: res.data.commonNameSort})
              if (res.data.outline && res.data.outline.length > 0) {
                  res.data.outline.forEach( value=>{
                    if(value.keyName === '危害特征'){
                        this.synopsis.push({name: '危害作物', value: value.value })
                    }else if(value.keyName === '发病周期'){
                        this.synopsis.push({name: '发病周期', value: value.value })
                    }else if(value.keyName === '发病条件及传染性'){
                        this.synopsis.push({name: '发病条件及传染性', value: value.value })
                    }
                  })
              }
          }
        })
      },

      //图片预览
      previewImg(arrImg , index){
          let arr = [] , viewArr = []
          arrImg.forEach(value=>{
              arr.push(value.imgUrl)
          })
          viewArr = [ ...arr.slice(index, arr.length) , ...arr.slice(0, index)    ]
          ImagePreview(viewArr);
      },

      //跳转下载
      toDownload() {
          // eslint-disable-next-line no-undef
          var data = OpenInstall.parseUrlParams();
          // eslint-disable-next-line no-undef
          new OpenInstall({
              /*appKey必选参数，openinstall平台为每个应用分配的ID*/
              appKey : "pzm0rx",
              /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
              //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
              /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
              //preferWakeup:true,
              /*自定义遮罩的html*/
              //mask:function(){
              //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
              //},
              /*openinstall初始化完成的回调函数，可选*/
              onready : function() {
                  var m = this, button = document.getElementById("downloadButton");
                  button.style.visibility = "visible";

                  /*在app已安装的情况尝试拉起app*/
                  m.schemeWakeup();
                  /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                  button.onclick = function() {
                      m.wakeupOrInstall();
                      return false;
                  }
              }
          }, data);
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '@/styles/encyclopediaShare/index';
</style>
